import { createFileRoute } from "@tanstack/react-router";

import { BASE_COLOR } from "~/components/feature/results/components/ResultsOtherAccounts";
import { DetailPage } from "~/components/feature/shared/components/DetailPage";

export const Route = createFileRoute(
  "/_app/dashboard/results/other-accounts/$category/detail",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { category } = Route.useParams();
  return (
    <DetailPage
      tab="other-accounts"
      category={category}
      targetMetric="results"
      baseColor={BASE_COLOR}
    />
  );
}
